import { render, staticRenderFns } from "./DevolucionBodegaSueltosReview.vue?vue&type=template&id=1e87db5d&scoped=true"
import script from "./DevolucionBodegaSueltosReview.vue?vue&type=script&lang=js"
export * from "./DevolucionBodegaSueltosReview.vue?vue&type=script&lang=js"
import style0 from "./DevolucionBodegaSueltosReview.vue?vue&type=style&index=0&id=1e87db5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e87db5d",
  null
  
)

export default component.exports